import { render, staticRenderFns } from "./AgGridWrapper.vue?vue&type=template&id=a572df8c"
import script from "./AgGridWrapper.vue?vue&type=script&lang=js"
export * from "./AgGridWrapper.vue?vue&type=script&lang=js"
import style0 from "./AgGridWrapper.vue?vue&type=style&index=0&id=a572df8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports